import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import {
  AutoComplete,
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAge from "../../../../lib/hooks/useAge";
import useChannelHeader from "../../../../lib/hooks/useChannelHeader";
import useInstitution from "../../../../lib/hooks/useInstitution";
import useNation from "../../../../lib/hooks/useNation";
import useTouchpoint from "../../../../lib/hooks/useTouchpoint";
import useEState from "../../../../lib/hooks/useEState";
import { routes } from "../../../../routes";
import { YearOf, quarter } from "./dataReport";
import useYearFilter from "../../../../lib/hooks/useYearsFilter";

const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;

const Search = ({ onSearch, roleUser }) => {
  const navigate = useNavigate();
  const [searchForm] = Form.useForm();
  const [searchCollapse, setSearchCollapse] = useState(false);
  const [institution] = useInstitution();
  const [channelHeader] = useChannelHeader();
  const [age] = useAge();
  const [nation] = useNation();
  const [yearList] = useYearFilter();
  const [estates, estateList] = useEState();

  const [nameOffice, setNameOffice] = useState();
  const [dataInstitution, setDataInstitution] = useState([]);
  const { searchValues, setSearchValues, pageValues, setPageValues } =
    useTouchpoint();

  const handleChange = (value) => {
    //console.log(`Selected: ${value}`);
  };

  const handleClearSearchForm = () => {
    searchForm.resetFields();
    onSearch({});
  };

  //เลือกชื่อนามสกุล
  const onSelectName = (value, option) => {
    // console.log(option);
    setNameOffice(option);
  };

  const getInstitution = () => {
    let newValue = [];
    institution.map((item) => {
      newValue.push({ id: item.id, value: item.institutionNameTh });
    });
    setDataInstitution(newValue);
  };

  useEffect(() => {
    getInstitution();
  }, [institution]);
  //institution

  return (
    <Content>
      <Form>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <div className="flex justify-between items-center">
              <Text
                level={4}
                style={{ marginTop: 15, marginBottom: 15 }}
                className="headder-text-customer"
              >
                คลังข้อมูล Touch point
              </Text>
              {roleUser[0]?.isCreate && (
                <div>
                  <Space>
                    <Button
                      type="primary"
                      onClick={() =>
                        navigate(routes.add_customer_touchpoint, {
                          state: {
                            action_type: "CREATE",
                          },
                        })
                      }
                    >
                      <PlusOutlined /> เพิ่มข้อมูล
                    </Button>
                  </Space>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Form>

      <Form
        layout={"vertical"}
        name="search"
        form={searchForm}
        onFinish={(value) => onSearch(value)}
        style={{
          padding: 20,
          backgroundColor: "#FCFCFC",
          borderRadius: "12px",
          border: "1px solid #F2F2F2",
        }}
      >
        <Row gutter={[24, 16]}>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"institutionId"}>
              <AutoComplete
                filterOption={true}
                options={dataInstitution}
                onSelect={onSelectName}
              >
                <Input placeholder="ชื่อหน่วยงาน" prefix={<SearchOutlined />} />
              </AutoComplete>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"channel"}>
              <Select
                mode="multiple"
                placeholder="ช่องทาง Touch Point "
                onChange={handleChange}
                style={{
                  width: "100%",
                }}
              >
                {channelHeader.map((item, i) => {
                  return (
                    <Option key={i} value={item.id}>
                      {item.value}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"yearOfBudget"}>
              <Select
                mode="multiple"
                placeholder="ปีงบประมาณ"
                onChange={handleChange}
                style={{
                  width: "100%",
                }}
              >
                {yearList?.map((item, i) => {
                  return (
                    <Option key={i} value={item.value}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name={"quarterOfBudget"}>
              <Select
                mode="multiple"
                placeholder="รายไตรมาส"
                //   defaultValue="a1"
                onChange={handleChange}
                style={{
                  width: "100%",
                }}
              >
                {quarter.map((item, i) => {
                  return (
                    <Option key={i} value={item.value}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name={"groupsByNationality"}>
              <Select
                mode="multiple"
                placeholder="กลุ่มลูกค้าตามสัญชาติ"
                //   defaultValue="a1"
                onChange={handleChange}
                style={{
                  width: "100%",
                }}
              >
                {nation.map((item, i) => {
                  return (
                    <Option key={i} value={item}>
                      {item}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name={"groupsByAge"}>
              <Select
                mode="multiple"
                placeholder="กลุ่มลูกค้าตามอายุ"
                //   defaultValue="a1"
                onChange={handleChange}
                style={{
                  width: "100%",
                }}
              >
                {age.map((item, i) => {
                  return (
                    <Option key={i} value={item}>
                      {item}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name="estateName">
              <AutoComplete filterOption={true} options={estateList}>
                <Input
                  placeholder="ชื่อนิคมอุตสาหกรรม"
                  prefix={<SearchOutlined />}
                />
              </AutoComplete>
            </Form.Item>
          </Col>

          <Col span={24} align="right">
            <Space>
              <Button onClick={handleClearSearchForm}>ล้างข้อมูล</Button>
              <Button type="primary" htmlType="submit">
                ค้นหา
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Content>
  );
};

export default Search;
